module.exports = __webpack_public_path__ + "img/upgrade_page_mobile_banner.5c8670ad.png";